import React from "react";
import Axios from "axios";
import axios from "services/axios";
import { Button, Card, message, Spin, Tooltip, Tag } from "antd";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import momentTZ from "moment-timezone";
import _ from "lodash";
import { getCarName, errorMessage } from "../../../../Utils";
import ModalDownload from "../../Component/Modal/ModalDownload";
import ModalSendToMobbi from "../../Component/Modal/ModalSendToMobbi";

let cancelToken;
class TradeInProgress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tradeIn: [],
      request: [],
      isLoading: true,
      confirmLoading: false,
      disableButton: true,
      openModal: false,
      fileList: null,
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "date", direction: "desc" },
      visbleModalDownload: false,
      visibleModalSendToMobbi: false,
      dataConfirm: {},
    };
    this.visibleModalDownload = this.visibleModalDownload.bind(this);
    this.visibleModalSendToMobbi = this.visibleModalSendToMobbi.bind(this);
    this.sendToMobbi = this.sendToMobbi.bind(this);
  }

  componentDidMount() {
    this.fetchTradeIn(this.state.page, this.state.limit);
  }

  orderBy(sort) {
    let key = "date";
    let value = "DESC";

    //Get Key
    if (sort.name === "Mobil Bekas") key = "carName";
    else if (sort.name === "Mobil Baru") key = "newCar";
    else if (sort.name === "Salesman") key = "salesman";
    else if (sort.name === "Hari/Tgl Approval") key = "date";

    //Get Value
    if (sort.direction === "asc") value = "ASC";
    else if (sort.direction === "desc") value = "DESC";

    return `${key}=${value}`;
  }

  async fetchTradeIn(page, limit) {
    const order = this.orderBy(this.state.sort);
    const query = `${order}&&page=${page}&&limit=${limit}&&search=${
      this.state.search || ""
    }`;

    if (cancelToken) {
      cancelToken.cancel("Operation canceled due to new request");
    }
    cancelToken = Axios.CancelToken.source();

    const data = await axios
      .get(`admin-panel/trade-in/new-approval?${query}`, {
        cancelToken: cancelToken.token,
      })
      .then((result) => {
        this.setState({
          tradeIn: result.data.approvalTradeIn,
          request: result.data.request,
          page: result.data.page,
          limit: result.data.limit,
          count: result.data.count,
          isLoading: false,
        });
      })
      .catch((err) => {
        if (!Axios.isCancel(err)) {
          errorMessage(err.response || err);
          this.setState({ isLoading: false });
        }
      });
  }

  async sendToMobbi(item) {
    try {
      this.setState({ confirmLoading: true, isLoading: true });
      let bookingId = _.get(item, "Appraisal.Booking.MobbiPayload.bookingId");
      await axios.put(
        `/admin-panel/mobbi/re-send-potential-buyer/booking/${bookingId}`,
        {}
      );

      this.setState({ confirmLoading: false, visibleModalConfirm: false });
      message.success("Success Send To Mobbi");
      this.fetchTradeIn(1, this.state.limit);
    } catch (e) {
      if (e.response) {
        if (e.response.data || e.response.message) {
          message.error(
            e.response.data.message || e.response.message || e.response.data
          );
        } else {
          message.error("Error Send to Mobbi");
        }
      } else {
        message.error("Error Send to Mobbi");
      }
      this.setState({ confirmLoading: false, isLoading: false });
    }
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchTradeIn(page, limit);
  }

  formatRupiah(number) {
    const data = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return data;
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "8em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  visibleModalDownload = (val) => {
    this.setState({ visbleModalDownload: val });
  };

  visibleModalSendToMobbi = (val, data) => {
    this.setState({ visibleModalSendToMobbi: val, dataConfirm: data });
  };

  getPotentialBuyer = (approval, no) => {
    let potentialBuyer = "-";
    let booking = _.get(approval, "Appraisal.Booking");
    if (booking && booking.sourceOfRequest === "MOBBI") {
      let mobbiPayload = booking.MobbiPayload;
      if (mobbiPayload) {
        if (no == 1) {
          if (mobbiPayload.isMobbi) potentialBuyer = "MOBBI88";
          else potentialBuyer = "TRUST";
        } else if (no == 2) {
          if (mobbiPayload.isPotentialBuyerMobbiToTrust) {
            potentialBuyer = "TRUST";
          }
        }
      }
    }
    return potentialBuyer;
  };

  isShowActionDetail = (approval) => {
    let isShow = true;
    let booking = _.get(approval, "Appraisal.Booking");
    if (booking && booking.sourceOfRequest === "MOBBI") {
      let mobbiPayload = booking.MobbiPayload;
      if (mobbiPayload) {
        if (mobbiPayload.isMobbi) {
          if (mobbiPayload.isPotentialBuyerMobbiToTrust == false) {
            isShow = false;
          }
        }
      }
    }

    return isShow;
  };

  isShowActionSendToMobbi = (approval) => {
    let isShow = false;
    let booking = _.get(approval, "Appraisal.Booking");
    if (booking && booking.sourceOfRequest === "MOBBI") {
      let mobbiPayload = booking.MobbiPayload;
      if (mobbiPayload) {
        if (mobbiPayload.isMobbi) {
          if (mobbiPayload.isSendMobbiPotentialBuyer == false) {
            isShow = true;
          }
        }
      }
    }

    return isShow;
  };

  render() {
    //Columns
    const columns = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name: "Status",
        options: {
          sort: false,
        },
      },
      {
        name: "Potential Buyer 1",
      },
      {
        name: "Potential Buyer 2",
      },
      {
        name: "Mobbi Id",
      },
      {
        name: "Nomor Polisi",
        options: {
          sort: false,
        },
      },
      {
        name: "Mobil Bekas",
        options: {
          sort: true,
        },
      },
      {
        name: "Mobil Baru",
        options: {
          sort: true,
        },
      },
      {
        name: "No Booking",
        options: {
          sort: false,
        },
      },
      {
        name: "Salesman",
        options: {
          sort: true,
        },
      },
      {
        name: "Cabang",
        options: {
          sort: false,
        },
      },
      {
        name: "Area",
        options: {
          sort: false,
        },
      },
      {
        name: "Hari/Tgl Approval",
        options: {
          sort: true,
        },
      },
    ];

    //Data New Car
    const tradeIn = this.state.tradeIn.map((item, idx) => {
      const carName = getCarName(item.Appraisal.carDetail);
      const branch = item.Appraisal.Booking.SalesProfile.SalesBranch
        ? item.Appraisal.Booking.SalesProfile.SalesBranch.branch
        : null;
      const area = item.Appraisal.Booking.SalesProfile.SalesBranch
        ? item.Appraisal.Booking.SalesProfile.SalesBranch.area
        : null;
      let isShowActionDetail = this.isShowActionDetail(item);
      let isShowActionSendToMobbi = this.isShowActionSendToMobbi(item);

      let mobbiId = _.get(item, "Appraisal.Booking.MobbiPayload.mobbiId");
      return [
        <div>
          {isShowActionDetail && (
            <Link
              to={{
                pathname: `/home/approval/trade-in-progress/${item.id}`,
                query: { status: "progress" },
              }}>
              <Tooltip placement="bottom" title="Detail Trade In">
                <Button icon="bars" style={{ marginRight: 10 }} />
              </Tooltip>
            </Link>
          )}

          {isShowActionSendToMobbi && (
            <Tooltip placement="bottom" title="Send Potential Buyer To Mobbi">
              <Button
                style={{
                  marginRight: 10,
                  backgroundColor: "#52c41a",
                  color: "white",
                }}
                icon="check"
                onClick={() => this.visibleModalSendToMobbi(true, item)}
              />
            </Tooltip>
          )}
        </div>,
        <Tag color="blue">New Approval</Tag>,
        this.getPotentialBuyer(item, 1),
        this.getPotentialBuyer(item, 2),
        mobbiId,
        item.Appraisal.licensePlate,
        item.Appraisal.carName || carName,
        item.NewCar ? item.NewCar.carName : null,
        item.Appraisal.Booking.noBooking,
        item.Appraisal.Booking.SalesProfile.name,
        branch,
        area,
        momentTZ(item.createdAt)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: this.state.limit,
      count: this.state.count,
      page: this.state.page - 1,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
            break;
        }
      },
    };

    return (
      <Card
        title="List Trade In Dalam Proses"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <div style={{ marginBottom: 10 }}>
          <Button onClick={() => this.visibleModalDownload(true)}>
            Download Report
          </Button>
        </div>
        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title="List Trade In Dalam Proses"
              data={tradeIn}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>

        <ModalDownload
          visible={this.state.visbleModalDownload}
          visibleModal={this.visibleModalDownload}
          status="new-approval"
        />

        <ModalSendToMobbi
          confirmLoading={this.state.confirmLoading}
          data={this.state.dataConfirm}
          visible={this.state.visibleModalSendToMobbi}
          sendButton={this.sendToMobbi}
          visibleModal={this.visibleModalSendToMobbi}
        />
      </Card>
    );
  }
}

export default TradeInProgress;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/TradeIn/InProgress/TradeIn.js